import api from '@/api/sisImportTemplates/possibleValues'
import baseModule from '@/store/shared/graphql'

const STORE_TYPE = 'SIS_IMPORT_TEMPLATE_POSSIBLE_VALUES'
const API_DATA_KEY = 'importTemplatePossibleValues'
const API_DATA_BY_ID_KEY = 'componentName'
const defaultModule = baseModule(STORE_TYPE, API_DATA_BY_ID_KEY, API_DATA_KEY, api)

export default { ...defaultModule, namespaced: true }
